module.exports = __webpack_public_path__ + "img/kikuyu.70fffea0.svg";